/*!
=========================================================
* Regiform IMS Frontend - Input Component
=========================================================
* Standalone input component for filtering/search functionality
* Built with Ant Design Input, follows TextInput styling patterns
=========================================================
*/
import { Input as AntInput } from "antd";
import PropTypes from "prop-types";
import { useMemo } from "react";
import React from "react";
import "./Input.css";

function Input({
  placeholder,
  value,
  onChange = () => {},
  disabled = false,
  prefix,
  suffix,
  allowClear = true,
  className = "",
  style = {},
  ...otherProps
}) {
  // Memoize className to prevent recreation on every render
  const computedClassName = useMemo(() => {
    return `common-input ${disabled ? "disabled-field" : ""} ${className}`;
  }, [disabled, className]);

  return (
    <AntInput
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      prefix={prefix}
      suffix={suffix}
      allowClear={allowClear}
      className={computedClassName}
      style={style}
      {...otherProps}
    />
  );
}

Input.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  allowClear: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default React.memo(Input);
